import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TileComponent } from './tile/tile.component';
import { TilesComponent } from './tiles/tiles.component';
import { ContactsComponent } from './contacts/contacts.component';
import { ContactComponent } from './contact/contact.component';
import { DOCUMENT } from '@angular/common';
import { ModalPhoneComponent } from './contact/modal-phone/modal-phone.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TrackingContactUsService } from './tracking/tracking-contact-us.service';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { windowScrollerServiceFactory } from './services/window-scroller.service.provider';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UnauthorizedErrorComponent } from './errorsPage/unauthorizedError/unauthorized-error.component';
import { NotFoundErrorComponent } from './errorsPage/notFoundError/not-found-error.component';
import { EchatService } from './contact/echat/echat.service';
import { DjingoService } from './library/djingo.service';

@NgModule({
  declarations: [
    AppComponent,
    TileComponent,
    TilesComponent,
    ContactsComponent,
    ContactComponent,
    ModalPhoneComponent,
    UnauthorizedErrorComponent,
    NotFoundErrorComponent,
  ],
  imports: [BrowserModule, NgbModule, AppRoutingModule, HttpClientModule],
  providers: [
    EchatService,
    TrackingContactUsService,
    DjingoService,
    { provide: 'EnvironmentProvider', useValue: environment },
    { provide: 'WindowContactUs', useValue: window },
    { provide: DOCUMENT, useValue: document },
    {
      provide: 'WindowScrollerService',
      useFactory: windowScrollerServiceFactory,
      deps: [DeviceDetectorService, 'WindowContactUs'],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
